module.exports = __webpack_public_path__ + "static/media/icon_ping-pong.fec6cdd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_ping-pong.svg
// module id = 169
// module chunks = 0